import React from 'react';
import { useDispatch } from 'react-redux';
import { setShowMiniCart } from '../../Actions/Cart.action';
import MiniCartIcon from './MiniCartIcon';
import { useTypedSelector } from '../../Hooks/useTypedSelector';

const MiniCartButton = () => {
  const dispatch = useDispatch();
  const userIsLoggedIn = useTypedSelector(
    (state) => state.userInfo.current != null
  );

  return (
    <>
      <button
        className="px-2 py-3 store-screen:mr-0 store-screen:py-4 lg:-mr-2 lg:py-2 hover:[&_.icon]:scale-110"
        onClick={() => dispatch(setShowMiniCart(true))}
      >
        <MiniCartIcon />
      </button>
    </>
  );
};

export default MiniCartButton;
